import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { QueryResult } from '../shared/object/queryResult.model';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class CheckinCheckoutService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerReporteVentasCheckResumen(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cantidad_elementos
                    tiempo_max
                    tiempo_min
                    tiempo_prom
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        console.log('response', { response });
        const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasCheckResumenExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerReporteVentasCheckDetalle(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        // listaRubro: any[];
        // listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    numero_pedido
                    numero_nota_venta
                    numeros_factura
                    rut_empresa
                    sucursal_codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    nombrecomuna
                    codigo
                    nombre
                    tiempo
                    rango
                    hora_registro
                    hora_termino
                    fecha
                    motivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckDetalle;
        console.log('respuesta', { respuesta });
        callback({ mensajes, respuesta });
      }
    );
  }
  obtenerReporteVentasCheckDetalleExcel(
    inputParams: {
      entidad: {
        rut_empresa: number;
        sucursal_codigo: number;
        fecha_desde: Date;
        fecha_hasta: Date;
        listaVendedor: any[];
        // listaRubro: any[];
        // listaFamilia: any[];
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: checkin_checkoutInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            checkin_checkout {
              obtenerReporteVentasCheckDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.checkin_checkout.obtenerReporteVentasCheckDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }
}
